<template>
  <div class="config-list">
    <StoreLocatorListItem
      v-for="item in storeLocatorItemsWithRestrictions"
      :key="item.route"
      :title="$t(item.title)"
      :description="$t(item.description)"
      @edit="handleNavigation(item.route)"
    />
  </div>
</template>

<script lang="ts">
import StoreLocatorListItem from "@/components/BusinessAddresses/StoreLocatorListItem.vue";
import { isFeatureFlagEnabled, FEATURE_FLAG } from "../../../helpers/posthog";

export default {
  name: "StoreLocatorTabs",
  components: {
    StoreLocatorListItem
  },
  data() {
    return {
      storeLocatorItems: [
        {
          title: "message.storeLocator.contactAndSectionsTitle",
          description: "message.storeLocator.contactAndSectionsDescription",
          route: "store-locator-config-manage"
        },
        {
          title: "message.storeLocator.faqItemTitle",
          description: "message.storeLocator.faqItemDescription",
          route: "store-locator-tab-faq"
        }
      ]
    };
  },
  computed: {
    isFaqEnabled() {
      return isFeatureFlagEnabled(FEATURE_FLAG.CN_6573_FAQ_STORE_LOCATOR);
    },
    storeLocatorItemsWithRestrictions() {
      if (!this.isFaqEnabled) {
        return this.storeLocatorItems.filter(
          item => item.route !== "store-locator-tab-faq"
        );
      }
      return this.storeLocatorItems;
    }
  },
  methods: {
    handleNavigation(route) {
      this.$router.push({
        name: route,
        params: { id: this.$route.params.id }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.config-list {
  width: 100%;
}
</style>
